import React from "react";
import IconSpace1 from "../../assets/spaces-icons/1.png";
import IconSpace2 from "../../assets/spaces-icons/2.png";
import IconSpace4 from "../../assets/spaces-icons/4.png";
import IconSpace5 from "../../assets/spaces-icons/5.png";
import IconSpace6 from "../../assets/spaces-icons/6.png";

export default function AppInfo({ application }) {
  const app = applications[application];
  const appIcon = app.icon;
  const appName = app.name;

  return (
    <div>
      <div className="flex items-center justify-center mb-6">
        <div className="flex items-center">
          <img src={appIcon} alt={appName} className="w-16 h-16" />
        </div>
      </div>

      <div className="text-center mb-6">
        <h2 className="text-2xl font-semibold text-white">Invitation to {appName}</h2>
        <p className="text-gray-400 text-base mt-2">Complete your registration to get started</p>
      </div>
    </div>
  );
}

const applications = {
  accounting: {
    id: "accounting",
    name: "Selego",
    icon: IconSpace1,
    url: "/",
    subtitle: "Financial management",
    terms: "https://app.selego.co/terms-privacy",
  },
  selecole: {
    id: "selecole",
    name: "Selecole",
    icon: IconSpace4,
    url: "/selecole",
    subtitle: "Education platform",
    terms: "https://app.selego.co/terms-privacy",
  },
  rfp: {
    id: "rfp",
    name: "RFP",
    icon: IconSpace6,
    url: "/missions_ao/search",
    subtitle: "Request for proposals",
    terms: "https://app.selego.co/terms-privacy",
  },
};
